import { createBrowserRouter, Navigate } from "react-router-dom";

import { ProtectedRoute } from "@/components/auth/protected-route";
import { Shell } from "@/components/layout/shell";
import PlaygroundPage from "@/playground/playground-page";
import ApiKeysPage from "@/pages/api-keys";
import AssetDetailPage from "@/pages/asset-detail";
import AssetsPage from "@/pages/assets";
import CompliancePage from "@/pages/compliance";
import DashboardPage from "@/pages/dashboard";
import EvaluationPage from "@/pages/evaluation";
import SkillsPage from "@/pages/skills";
import LoginPage from "@/pages/login";
import NotFoundPage from "@/pages/not-found";
import ObservabilityPage from "@/pages/observability";
import PoliciesPage from "@/pages/policies";
import PolicyDetailPage from "@/pages/policy-detail";
import ProvidersPage from "@/pages/providers";
import RegisterPage from "@/pages/register";
import RiskPage from "@/pages/risk";
import SettingsPage from "@/pages/settings";
import PlatformTenantsPage from "@/pages/platform/tenants-page";
import SettingsAllowedOriginsTab from "@/pages/settings/allowed-origins-tab";
import SettingsDataProtectionTab from "@/pages/settings/data-protection-tab";
import SettingsFxRateTab from "@/pages/settings/fx-rate-tab";
import SettingsProfileTab from "@/pages/settings/profile-tab";
import SettingsTenantTab from "@/pages/settings/tenant-tab";
import SettingsUsersTab from "@/pages/settings/users-tab";
import WorkspaceDetailPage from "@/pages/workspace-detail";
import WorkspacesPage from "@/pages/workspaces";
import { ROUTES } from "@/lib/constants";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <Navigate to={ROUTES.DASHBOARD} replace />,
  },
  {
    path: ROUTES.LOGIN,
    element: <LoginPage />,
  },
  {
    path: ROUTES.REGISTER,
    element: <RegisterPage />,
  },
  {
    element: (
      <ProtectedRoute>
        <Shell />
      </ProtectedRoute>
    ),
    children: [
      { path: ROUTES.DASHBOARD, element: <DashboardPage /> },
      { path: ROUTES.PLAYGROUND, element: <PlaygroundPage /> },
      { path: ROUTES.API_KEYS, element: <ApiKeysPage /> },
      { path: ROUTES.OBSERVABILITY, element: <ObservabilityPage /> },
      { path: ROUTES.POLICIES, element: <PoliciesPage /> },
      { path: `${ROUTES.POLICIES}/:id`, element: <PolicyDetailPage /> },
      { path: ROUTES.ASSETS, element: <AssetsPage /> },
      { path: `${ROUTES.ASSETS}/:id`, element: <AssetDetailPage /> },
      { path: ROUTES.RISK, element: <RiskPage /> },
      { path: ROUTES.COMPLIANCE, element: <CompliancePage /> },
      { path: ROUTES.EVALUATION, element: <EvaluationPage /> },
      { path: ROUTES.SKILLS, element: <SkillsPage /> },
      { path: ROUTES.PROVIDERS, element: <ProvidersPage /> },
      { path: ROUTES.WORKSPACES, element: <WorkspacesPage /> },
      { path: `${ROUTES.WORKSPACES}/:id`, element: <WorkspaceDetailPage /> },
      // Super-admin only — page itself redirects to dashboard if the
      // caller isn't super_admin. BE rejects 403 on every endpoint.
      { path: ROUTES.PLATFORM_TENANTS, element: <PlatformTenantsPage /> },
      {
        path: ROUTES.SETTINGS,
        element: <SettingsPage />,
        children: [
          { index: true, element: <Navigate to={ROUTES.SETTINGS_PROFILE} replace /> },
          { path: "profile", element: <SettingsProfileTab /> },
          { path: "tenant", element: <SettingsTenantTab /> },
          { path: "users", element: <SettingsUsersTab /> },
          { path: "fx-rate", element: <SettingsFxRateTab /> },
          {
            path: "allowed-origins",
            element: <SettingsAllowedOriginsTab />,
          },
          {
            path: "data-protection",
            element: <SettingsDataProtectionTab />,
          },
          // Sesi POLISH-NAV-API (v0.29.0): Penyedia AI promoted
          // to top-level ``/providers``. The old nested path
          // redirects so bookmarks + the FE-4 sub-route active
          // match keep working through the rebrand.
          {
            path: "providers",
            element: <Navigate to={ROUTES.PROVIDERS} replace />,
          },
        ],
      },
    ],
  },
  { path: "*", element: <NotFoundPage /> },
]);
